import CalculatorMobileFilter from "./calculatorMobileFiter";
import CalculatorResults from "../calculatorResults";

const CalculatorMobileLayout = ({
    formView,
    defaultData,
    backToFilterView,
    moveToFormView,
    buttonLoading,
    allowDistanceEdit
}) => {
    return (
        <>
            {
                formView
                ?
                <CalculatorResults backToFilterView={backToFilterView}/>
                :
                <CalculatorMobileFilter
                    defaultData={defaultData} 
                    moveToFormView={moveToFormView}
                    buttonLoading={buttonLoading}
                    allowDistanceEdit={allowDistanceEdit}
                />
            }
        </>
    );
}

export default CalculatorMobileLayout;